export enum RoleEnum {
  consumer,
  retailer,
  creator,
}
